import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as Global from 'src/app/global';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomService } from 'src/app/services/custom.service';
import { AppComponent } from 'src/app/app.component';
import { passwordConfirmationValidator } from 'src/app/validators/custom-form.validator';

@Component({
    selector: 'app-otp-verification',
    templateUrl: './otp-verification.component.html',
    styleUrls: ['./otp-verification.component.css']
})

export class OtpVerificationComponent implements OnInit {
    Global = Global;
    otpForm: FormGroup;
    otpType: any = null;
    otpToken: any = null;

    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private toastr: ToastrService,
        private router: Router,
        private spinner: NgxSpinnerService,
        private customService: CustomService,
        private appComponent: AppComponent,
        private activatedRoute: ActivatedRoute,
    ) {
        this.otpForm = formBuilder.group({
            otp_code: [null, Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(6), Validators.maxLength(6)])],
            password: [null],
            password_confirmation: [null],
        });

        const rt = this.appComponent.getActivatedRouteChild(this.activatedRoute);
        rt.data.subscribe((data: any) => {
            if (data?.otpData?.type) {
              console.log(data);
                this.otpType = data?.otpData?.type

                if (this.otpType == 'user-resetpassword') {
                    this.otpForm.get('password')?.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(20)]);
                    this.otpForm.get('password_confirmation')?.setValidators([Validators.required, passwordConfirmationValidator("password")]);

                    this.otpForm.get('password')?.updateValueAndValidity();
                    this.otpForm.get('password_confirmation')?.updateValueAndValidity();
                }
            } else {
                this.toastr.error("OTP_TYPE is not defined in app.component.ts");
            }
        });
    }

    ngOnInit(): void {
        this.otpToken = this.activatedRoute.snapshot.paramMap.get('token');
        this.validateToken()
    }

    onOtpKeyUp(event: any) {
        this.otpForm.get('otp_code')?.setValue(event ?? null)
    }

    submit(event: any) {
        console.log(this.otpForm);

        this.otpForm.markAllAsTouched();
        Global.scrollToQuery(".form-control.is-invalid");

        if (this.otpForm.valid) {
            event.target.classList.add('btn-loading');
            event.target.disabled = true;

            let payload: any = {
                'type': this.otpType,
                'verification_token': this.otpToken,
                'otp_code': this.otpForm.value.otp_code ?? null,
            }

            if (['user-resetpassword'].includes(this.otpType)) {
                payload.password = this.otpForm.value.password ?? null;
                payload.password_confirmation = this.otpForm.value.password_confirmation ?? null;
            }

            this.authService.otpVerify(payload).subscribe(res => {
                const data = res.data;
                if (res.status == 'success') {
                    this.toastr.success(res.message);

                    if (['user-register', 'user-login','seller-register'].includes(this.otpType)) {
                        this.authService.userSuccessLogin({
                            'token': data?.token ?? null,
                            'user': data?.user ?? null,
                        })
                    } else if (['user-resetpassword'].includes(this.otpType)) {
                        this.router.navigate(['/login'])
                    }
                } else if (res.status == 'val_error') {
                    this.toastr.error(Global.getValidationMessage(data?.errors ?? []));
                } else {
                    this.toastr.error(res.message);
                }

                event.target.classList.remove('btn-loading');
                event.target.disabled = false;
            }, err => {
                //this.toastr.error(Global.getServerErrorMessage(err));

                event.target.classList.remove('btn-loading');
                event.target.disabled = false;
            });
        }
    }

    resendOtp(event: any) {
        event.target.classList.add('btn-loading');
        event.target.disabled = true;

        this.authService.otpResend({
            'type': this.otpType,
            'verification_token': this.otpToken,
        }).subscribe(res => {
            const data = res.data;
            if (res.status == 'success') {
                Global.disableButtonForTimeFrame(120, "resendotp-button")
                this.toastr.success(res.message)
            } else if (res.status == 'val_error') {
                this.toastr.error(Global.getValidationMessage(data?.errors ?? []));
            } else {
                this.toastr.error(res.message);
            }

            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
        }, err => {
            //this.toastr.error(Global.getServerErrorMessage(err));

            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
        });
    }

    otpInfoText: string = ""
    validateToken() {
        this.spinner.show();
        this.authService.otpInit({
            'type': this.otpType,
            'verification_token': this.otpToken,
        }).subscribe(res => {
            const data = res.data;
            if (res.status == 'success') {
                this.otpInfoText = data?.info_msg ?? "";
                if (data?.otp_resend_left > 0) {
                    Global.disableButtonForTimeFrame(data?.otp_resend_left, "resendotp-button")
                }
            } else if (res.status == 'val_error') {
                this.toastr.error(Global.getValidationMessage(data?.errors ?? []));
                this.customService.abortError(419);
            } else {
                this.toastr.error(res.message);
                this.customService.abortError(419);
            }

            this.spinner.hide();
        }, err => {
            this.customService.abortError(500);
            //this.toastr.error(Global.getServerErrorMessage(err));
            this.spinner.hide();
        });
    }
}
